module.exports = "/_next/static/images/ccfa7b51260c98e145a999857264ada1-rewards-illustration@2x.png.webp";